import type { BlueprintIconNames } from 'components/icons/blueprint/BlueprintIconNames';

export const BlueprintIconsMap: Record<string, BlueprintIconNames> = {
  'address card': 'AddressCard',
  ambulance: 'Node',
  'american sign language interpreting': 'Node',
  anchor: 'Node',
  archive: 'Archive',
  'assistive listening systems': 'Node',
  at: 'Node',
  'balance scale': 'BalanceScale',
  beer: 'Node',
  bell: 'Bell',
  binoculars: 'Node',
  bolt: 'Risk',
  bomb: 'Node',
  book: 'Node',
  bookmark: 'Node',
  box: 'Object',
  briefcase: 'Briefcase',
  building: 'Building',
  bullhorn: 'Megaphone',
  bullseye: 'Goal',
  calculator: 'Node',
  calendar: 'Calendar',
  'calendar check': 'CalendarCheck',
  'calendar plus': 'Calendar',
  'calendar times': 'Calendar',
  certificate: 'Node',
  'chart line': 'ChartLine',
  'chart pie': 'ChartPie',
  clipboard: 'Clipboard',
  'clipboard list': 'ActionList',
  clock: 'Node',
  coffee: 'Node',
  cog: 'Function',
  cogs: 'System',
  columns: 'Node',
  comment: 'Comment',
  comments: 'Meeting',
  compass: 'Node',
  copy: 'Document',
  copyright: 'Organization',
  cube: 'Object',
  cubes: 'Objects',
  cut: 'Node',
  'dot circle': 'Node',
  edit: 'DocumentPencil',
  envelope: 'Envelope',
  'envelope open': 'Envelope',
  eraser: 'Node',
  exclamation: 'Issue',
  eye: 'Node',
  'fighter jet': 'Node',
  file: 'Document',
  'file pdf': 'Document',
  fire: 'Fire',
  'fire extinguisher': 'FireExtinguisher',
  flag: 'Flag',
  'flag checkered': 'Flag',
  folder: 'Folder',
  'folder open': 'Folder',
  futbol: 'Node',
  gamepad: 'Node',
  gavel: 'Decision',
  gem: 'Node',
  globe: 'Globe',
  'graduation cap': 'Graduate',
  hashtag: 'Node',
  home: 'Home',
  hospital: 'Building',
  hourglass: 'Node',
  'hourglass end': 'Node',
  'hourglass half': 'Node',
  image: 'Image',
  images: 'Image',
  inbox: 'Node',
  industry: 'Building',
  info: 'Information',
  language: 'Note',
  laptop: 'Laptop',
  leaf: 'Node',
  lightbulb: 'Node',
  'location arrow': 'Node',
  magnet: 'Node',
  map: 'Node',
  'map marker': 'Marker',
  'map pin': 'Marker',
  'map signs': 'Node',
  marker: 'Marker',
  mobile: 'Laptop',
  newspaper: 'Document',
  'paper plane': 'Node',
  paperclip: 'Node',
  paste: 'Node',
  paw: 'Node',
  'pen square': 'DocumentPencil',
  percent: 'Node',
  phone: 'AddressCard',
  plus: 'Plus',
  'plus circle': 'Plus',
  question: 'Question',
  registered: 'Node',
  retweet: 'Node',
  road: 'Node',
  rss: 'Node',
  save: 'Node',
  search: 'Node',
  share: 'Node',
  ship: 'Node',
  'shopping cart': 'Node',
  sitemap: 'Node',
  star: 'Node',
  'sticky note': 'Note',
  stopwatch: 'Node',
  sun: 'Node',
  table: 'Table',
  tag: 'Tag',
  tags: 'Tag',
  tasks: 'ActionList',
  'thumbs down': 'Node',
  'thumbs up': 'Action',
  thumbtack: 'Pin',
  tty: 'Node',
  umbrella: 'Node',
  university: 'Building',
  user: 'Person',
  'user circle': 'Person',
  'user plus': 'Persons',
  users: 'Persons',
  'utensil spoon': 'Node',
  warehouse: 'Node',
  weight: 'Node',
  wifi: 'Node',
  wrench: 'Activity'
};
